export const POSSIBLE_FOCUSABLE_ELEMENTS_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]';

const getPossibleFocusableElements = (container) => {
  const possibleFocusableElements = container.querySelectorAll(
    POSSIBLE_FOCUSABLE_ELEMENTS_SELECTOR
  );
  const possibleFocusableElementsArray = Array.from(possibleFocusableElements);
  return possibleFocusableElementsArray;
};

export default getPossibleFocusableElements;
